import react, { useState, useEffect } from "react";
import { authenticateGuideUser } from "./utils";
import GuideLogin from "./GuideLogin";

const AuthenticatedRoute = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [showAnExpiredTokenModal, setShowAnExpiredTokenModal] = useState(false);

    const showTheExpiredTokenModal = () => {
        setShowAnExpiredTokenModal(true);
    }

    const TheExpiredTokenModal = () => {
        return (
            <div className="modal-overlay">
                <div className="modal">
                    <h2>Session Expired</h2>
                    <p>Your session has expired. Please log in again.</p>
                    <GuideLogin fromExpiredTokenModal={true} closeExpiredTokenModal={setShowAnExpiredTokenModal(false)} />
                </div>
            </div>
        );
    }

    useEffect(() => {
        const authenticationData = authenticateGuideUser();
        authenticationData.then(data => {
            if(data && data.isLoggedIn) {
                setIsLoggedIn(true);
            } else {
                setIsLoggedIn(false);
                window.location.replace("/");
            }
        });
    }, []);

    return (
        <div>
            {showAnExpiredTokenModal && <TheExpiredTokenModal />}
            {react.cloneElement(children, { isLoggedIn, showTheExpiredTokenModal })}
        </div>
    )
}

export default AuthenticatedRoute;